<script setup lang="ts">
import type { IBadge } from '@/shared/ui/Badge/types';

const { t } = useI18n();

const props = withDefaults(defineProps<IBadge>(), {
  text: '',
  type: 'new_arrival',
});

const badgeText = computed(() => {
  switch (props.type) {
    case 'new_arrival':
      return t('badge.new');
    case 'liquidation':
      return t('badge.liquidation');
    case 'remained':
      return `${t('badge.remained')} ${props.text} ${t('badge.amountRemained')}`;
    case 'bought':
      return `${t('badge.bought')} ${props.text} ${t('badge.amountBought')}`;
    default:
      return '';
  }
});
</script>

<template>
  <div :class="['badge', `_${type}`]">
    {{ badgeText }}
  </div>
</template>

<style lang="less">
.badge {
  font-size: @size-x3;
  line-height: 67%;
  font-weight: 500;
  color: @color-oxford-blue;
  border-radius: 6px;
  width: fit-content;
  padding: @main-size 6px;

  &._liquidation {
    background-color: @color-mona-lisa;
  }

  &._bought {
    background-color: @color-jonquil;
  }

  &._remained {
    background-color: @color-periwinkle;
  }

  &._new_arrival {
    background-color: @color-reef;
  }

  @media @1024 {
    font-size: 10px;
  }
}
</style>
